<template>
  <div class="faces-container">
    <!-- Filter Section -->
    <div class="accordion" id="facesFilterAccordion">
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingFacesFilter">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#facesFilters"
            aria-expanded="true"
            aria-controls="facesFilters"
          >
            Filters (Click to Open)
          </button>
        </h2>
        <div
          id="facesFilters"
          class="accordion-collapse collapse show"
          aria-labelledby="headingFacesFilter"
        >
          <div class="accordion-body"> 
            <Form
              @submit="(values) => loadEvents(pagination.page, values)"

              ref="facesForm"
            >
              <!-- Site Filter Dropdown -->
              <div class="row ">
                <div class="col-md-3 col-sm-12">
                  <label for="selectedSite">Site Filter</label>
                  <Multiselect
                    v-model="selectedSite"
                    :class="{ 'multi-dark': $store.state.auth.status.dark }"
                    :options="sites"
                    :max-height="150"
                    :multiple="false"
                    :closeOnSelect="true"
                    :clearOnSelect="false"
                    :hideSelected="true"
                    :preserveSearch="true"
                    placeholder="Select a site"
                    label="name"
                    track-by="id"
                    @change="onSiteChange"
                  ></Multiselect>
                </div>
                <!-- Status Select -->
                <div class="col-md-3 col-sm-12">
                  <label for="selectedStatus">Status</label>
                  <Multiselect
                    v-model="selectedStatus"
                    :class="{ 'multi-dark': $store.state.auth.status.dark }"
                    :options="statuses"
                    :max-height="150"
                    :multiple="false"
                    :close-on-select="false"
                    :searchable="true"
                    :hideSelected="false"
                    :preserveSearch="true"
                    :allowEmpty="true"
                    placeholder="Select a status"
                    label="name"
                    track-by="value"
                  ></Multiselect>
                </div>
                <!-- Start Date Filter -->
                <div class="col-md-3 col-sm-12">
                  <label for="startDate">Start Date</label>
                  <input
                    type="date"
                    v-model="startDate"
                    id="startDate"
                    class="form-control"
                  />
                </div>
                <!-- End Date Filter -->
                <div class="col-md-3 col-sm-12">
                  <label for="endDate">End Date</label>
                  <input
                    type="date"
                    v-model="endDate"
                    id="endDate"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="row m-t-xs">
                <!-- Start Time Filter -->
                <div class="col-md-3 col-sm-12">
                  <label for="startTime">Start Time</label>
                  <input
                    type="time"
                    v-model="startTime"
                    id="startTime"
                    class="form-control"
                  />
                </div>
                <!-- End Time Filter -->
                <div class="col-md-3 col-sm-12">
                  <label for="endTime">End Time</label>
                  <input
                    type="time"
                    v-model="endTime"
                    id="endTime"
                    class="form-control"
                  />
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for="filterImage">Search by Face Image</label>
                  <div class="input-group">
                    <input
                      type="file"
                      id="filterImage"
                      class="form-control"
                      accept="image/*"
                      @change="handleFilterImageSelection"
                    />
                    <button 
                      type="button" 
                      class="btn btn-secondary"
                      @click="clearFilterImage"
                      v-if="filterImagePreview"
                    >
                      <i class="material-icons">close</i>
                    </button>
                  </div>
                  <div v-if="filterImagePreview" class="mt-3 text-center">
                    <img
                      :src="filterImagePreview" 
                      alt="Filter image preview"
                      class="img-fluid rounded"
                      style="height: 300px;"
                    />
                  </div>
                </div>
              </div>
              <!-- Gender / Glasses / Facial Hair filters -->
              <!-- <div class="row m-t-xs">
                <div class="col-md-3 col-xs-6 col-xxs-12">
                  <label for="gender" class="form-label">Gender</label>
                  <Field
                    id="gender"
                    class="form-select"
                    name="gender"
                    as="select"
                    v-model="gender"
                  >
                    <option value="" selected disabled>Select a gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </Field>
                  <ErrorMessage name="gender" class="error-feedback" />
                </div>
                <div class="col-md-3 col-xs-6 col-xxs-12">
                  <label for="facialHair" class="form-label">Facial Hair</label>
                  <Field
                    id="facialHair"
                    class="form-select"
                    name="facialHair"
                    as="select"
                    v-model="facialHair"
                  >
                    <option value="" selected disabled>Select an option</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </Field>
                  <ErrorMessage name="facialHair" class="error-feedback" />
                </div>
                <div class="col-md-3 col-xs-6 col-xxs-12">
                  <label for="glasses" class="form-label"
                    >Glasses / Sunglasses</label
                  >
                  <Field
                    id="glasses"
                    class="form-select"
                    name="glasses"
                    as="select"
                    v-model="glasses"
                  >
                    <option value="" selected disabled>Select an option</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </Field>
                  <ErrorMessage name="glasses" class="error-feedback" />
                </div>
              </div> -->
              <div class="row m-t-md" style="justify-content: center">
                <div class="" style="width: auto">
                  <button
                    :disabled="loading"
                    class="btn btn-primary"
                    style="max-width: 150px"
                    @click="fetchFaces(1)"
                  >
                    Search
                  </button>
                </div>

                <div class="col-12 width-auto" style="width: auto">
                  <!-- Clear Filters Button -->
                  <button
                    class="btn btn-secondary"
                    style="max-width: 150px"
                    @click="clearFilters"
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <br />
      <h1 class="table-heading" style="padding: 0; margin: 0">
        {{ $t("navigation.side.faces") }}
      </h1>
      <Pagination :config="pagination" :showTotal="true" @search="fetchFaces" /><br>
      <div class="row">
        <div class="col-auto d-flex align-items-center gap-3">
          <button
            class="btn btn-sm burger btn-primary"
            @click="toggleAllImages()"
          >
            <i v-show="showing === 'background'" class="material-icons">face</i
            ><i v-show="showing === 'face'" class="material-icons">image</i>
          </button>
          <span>Toggle All Images</span>
        </div>
        <div class="col-auto d-flex align-items-center gap-3">
          <button class="btn btn-sm burger btn-primary" @click="toggleBlur">
            <i class="material-icons">
              {{ privacyFilter ? "visibility_off" : "visibility" }}
            </i>
          </button>
          <span>{{
            privacyFilter ? "Disable Privacy Filter" : "Enable Privacy Filter"
          }}</span>
        </div>
        <div class="col-auto d-flex align-items-center gap-3">
          <button class="btn btn-sm burger btn-primary" @click="toggleSelectionMode">
            <i class="material-icons">
              {{ selectionModeActive ? "cancel" : "check_box_outline_blank" }}
            </i>
          </button>
          <span>{{ selectionModeActive ? "Exit Selection Mode" : "Select Multiple Faces" }}</span>
        </div>
        <div class="col-auto d-flex align-items-center gap-3 ms-auto">
          <button 
            v-if="selectionModeActive"
            class="btn btn-danger" 
            @click="reportSelectedFaces()"
            :disabled="selectedFaces.length === 0"
          >
            Report {{ selectedFaces.length }} Selected Face{{ selectedFaces.length !== 1 ? 's' : '' }}
          </button>
          <button 
            v-else
            class="btn btn-primary" 
            @click="openNewIncidentModal"
          >
            Create Custom Incident 
          </button>
        </div>
      </div>

      <!-- Faces Display Section -->
      <div class="faces-gallery mt-4 mb-4">
        <div
          v-show="!loading"
          v-for="face in faces"
          :key="face.id"
          class="card"
          :class="[
            face.status === 'alert' ? 'alert-border' : '',
            isSelectedStandard(face) ? 'selected-face' : '',
            selectionModeActive ? 'selection-mode' : ''
          ]"
          @click="selectionModeActive ? toggleFaceSelection(face) : null"
        >
          <div v-if="selectionModeActive" class="selection-indicator">
            <i class="material-icons" v-if="isSelectedStandard(face)">check_circle</i>
            <i class="material-icons" v-else>radio_button_unchecked</i>
          </div>
          <div
            class="image-container"
            :class="{ blurred: privacyFilter, zoomedBlurred : privacyFilter && face.showing === 'face' }"
            @contextmenu.prevent
          >
            <viewer :options="viewerOptions">
              <img
                v-show="face.showing === 'face'"
                :src="face.images.head.sas"
                alt="Face Image"
                class="face-image"
                @click="saveScrollPosition"
              />
              <img
                v-show="face.showing === 'background'"
                :src="face.images.background.sas"
                alt="Face Image"
                class="face-image"
                @click="saveScrollPosition"
              />
            </viewer>
          </div>
          <div class="face-details">
            <p>
              <strong>Date and Time:</strong> {{ face.created_at_formatted }}
            </p>
            <p>
              <strong>Age Range:</strong> {{ face.age_range }} 
            </p>
            <!-- Button for finding similiar faces currently not in use -->
            <!-- <button class="btn btn-primary" @click="findSimilarFaces(selectedFace)">Find Similar Faces</button> -->
            <div class="face-controls">
              <button
                class="btn btn-sm burger btn-primary"
                @click="toggleImage(face)"
              >
                <i v-show="face.showing === 'background'" class="material-icons"
                  >face</i
                ><i v-show="face.showing === 'face'" class="material-icons"
                  >image</i
                >
              </button>
              <button v-if="!selectionModeActive" class="btn btn-danger" @click="reportIncident(face)">
                Report Incident
              </button>
            </div>
          </div>
        </div>
        <div class="text-center">
          <p v-if="!loading && faces.length < 1">No faces found</p>
          <div class="wrapper" v-if="loading">
            <div class="sub-wrapper">
              <Loader />
            </div>
          </div>
        </div>
      </div>

      <!-- PAGINATION -->
      <Pagination :config="pagination" :showTotal="true" @search="fetchFaces" />
    </div>
  </div>

  <div
    class="modal fade"
    id="newIncidentModal"
    tabindex="-1"
    aria-labelledby="newIncidentModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header justify-content-center">
          <h3 id="newIncidentModalLabel" class="modal-title">New Incident</h3>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 me-3" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p class="text-center">Please ensure the image you upload matches the face in any evidence you have for this incident.</p>
          
          <div class="mb-3">
            <label for="incidentImage" class="form-label">Upload Image with Face</label>
            <input
              accept="image/*"
              type="file"
              id="incidentImage"
              class="form-control"
              @change="handleImageSelection"
            />
          </div>
          
          <div v-if="newIncidentImage" class="text-center mb-3">
            <div class="position-relative image-preview-container">
              <img 
                :src="imagePreview" 
                alt="Selected image" 
                class="img-fluid rounded" 
                style="max-height: 300px;"
              />
              <div 
                v-if="faceDetectionStatus === 'success'"
                v-for="(face, index) in detectedFaces" 
                :key="index"
                class="face-bounding-box"
                :class="{ 
                  'face-box-hover': hoveredFaceIndex === index, 
                  'face-box-selected': isSelectedCustomFace(index)
                }"
                :style="getBoundingBoxStyle(face)"
                @mouseover="hoveredFaceIndex = index"
                @mouseout="hoveredFaceIndex = null"
                @click="selectFace(index)"
              ></div>
            </div>
          </div>
          
          <div v-if="faceDetectionStatus === 'processing'" class="alert alert-info">
            <div class="d-flex align-items-center">
              <div class="spinner-border spinner-border-sm me-2" role="status">
                <span class="visually-hidden">Processing...</span>
              </div>
              Detecting faces in image...
            </div>
          </div>
          
          <div v-if="faceDetectionStatus === 'success'" class="alert alert-success">
            <div v-if="detectedFaces.length > 1">
              <div class="d-flex align-items-center mb-2">
                <i class="material-icons align-middle me-2">person_search</i>
                <span v-if="selectionMode === 'single'">Multiple faces detected! Please select the face you want to report.</span>
                <span v-else>Multiple faces detected! Select the faces you want to include in your report.</span>
              </div>
              <div v-if="selectionMode === 'multiple' && selectedFaceIndicies.length > 0" class="small">
                {{ selectedFaceIndicies.length }} face(s) selected
              </div>
            </div>
            <div v-else-if="this.detectedFaces.length === 1">
              <i class="material-icons align-middle me-2">check_circle</i>
              Face detected successfully! You can proceed with creating the incident.
            </div>
          </div> 
          
          <div v-if="faceDetectionStatus === 'success' && detectedFaces.length > 1" class="mt-3 mb-3">
            <div class="d-flex justify-content-center">
              <div class="btn-group" role="group" aria-label="Face selection mode">
                <input 
                  type="radio" 
                  class="btn-check" 
                  name="selectionMode" 
                  id="singleSelect" 
                  value="single"
                  v-model="selectionMode"
                >
                <label class="btn btn-outline-primary" for="singleSelect">
                  <i class="material-icons align-middle me-1" style="font-size:16px;">person</i> 
                  Select One Face
                </label>
                
                <input 
                  type="radio" 
                  class="btn-check" 
                  name="selectionMode" 
                  id="multiSelect" 
                  value="multiple"
                  v-model="selectionMode"
                >
                <label class="btn btn-outline-primary" for="multiSelect">
                  <i class="material-icons align-middle me-1" style="font-size:16px;">people</i> 
                  Select Multiple Faces
                </label>
              </div>
            </div>
            <small class="text-muted d-block text-center mt-1">
              {{ selectionMode === 'single' ? 'Click on one face to select it' : 'Click on faces to select/deselect them' }}
            </small>
          </div>

          <div v-if="faceDetectionStatus === 'error'" class="alert alert-danger">
            <i class="material-icons align-middle me-2">error</i>
            {{ faceDetectionError || 'No face detected in the image. Please upload a clear image with a visible face.' }}
          </div>
        </div>
        
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button 
            type="button" 
            class="btn btn-success" 
            @click="createNewIncident" 
            :disabled="isCreateButtonDisabled()"
          >
            Begin Incident Form
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import { Form, Field, ErrorMessage } from "vee-validate";
import Pagination from "../../components/Pagination.vue";
import ClientService from "../../services/client.service.js";
import authHeader from "../../services/auth-header";
import Loader from "../dashboard/Customised/Loader.vue";
import { DateTime } from "luxon";
import { Multiselect } from "vue-multiselect";
import { Viewer } from "v-viewer";
export default {
  name: "Faces",
  components: {
    Form,
    Field,
    ErrorMessage,
    Pagination,
    Loader,
    Multiselect,
  },
  data() {
    return {
      faces: [],
      selectedFace: null,
      pagination: {
        page: 1,
        showing: 24,
        maxPage: 1,
        total: 0,
      },
      dateFilter: "",
      faceIdFilter: "",
      cameraIdFilter: "",
      page: "",
      count: "",
      startFilter: "",
      endFilter: "",
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      isCardExpanded: false,
      privacyFilter: false,
      loading: false,
      selectedSite: null,
      gender: null,
      facialHair: null, // Fetch and combine 'beard' with 'mustache'
      glasses: null, // Fetch and combine 'sunglasses' with 'glasses'
      sites: [],
      statuses: [
        { name: "Alert", value: "alert" },
        { name: "Active", value: "active" },
      ],
      selectedStatus: null,
      showing: "background",
      scrollPosition: 0,
      newIncidentModal: null,
      newIncidentImage: null,
      imagePreview: null,
      detectedFaces: [],
      faceDetectionStatus: null, 
      faceDetectionError: null,
      filterImage: null,
      filterImagePreview: null,
      selectionModeActive: false,
      selectedFaces: [],
      hoveredFaceIndex: null,
      selectedFaceIndex: null,
      selectedFaceIndicies: [],
      selectionMode: 'single',
      viewerOptions: {
        hidden: () => {
          this.restoreScrollPosition();
        },
      },
    };
  },

  async created() {
    await this.loadSites();
    const storedBlurState = localStorage.getItem("privacyFilter");
    this.privacyFilter = storedBlurState === "true";
  },

  mounted() {
    this.newIncidentModal = new bootstrap.Modal(
      document.getElementById("newIncidentModal"),
      {
        keyboard: false,
      }
    );
  },

  watch: {
    selectionMode(newMode) {
      if (newMode === 'single') {
        if (this.selectedFaceIndicies.length > 0) {
          this.selectedFaceIndex = this.selectedFaceIndicies[0];
        }
      } else {
        if (this.selectedFaceIndex !== null) {
          this.selectedFaceIndicies = [this.selectedFaceIndex];
        }
      }
    }
  },

  methods: {
    fetchFaces(page = 1, siteId = this.selectedSiteId) {
      if (!siteId) {
        console.error("No site selected");
        return;
      }
      this.loading = true;
      // Update current page
      this.pagination.page = page;

      const params = {
        camera_id: this.cameraIdFilter,
        site_id: siteId, // Compulsory
        face_id: this.faceIdFilter,
        start: this.startFilter, // Assuming you have a startFilter data property for start date
        end: this.endFilter,
        page: this.pagination.page,
        count: this.pagination.showing,
        start_time: this.startTime,
        end_time: this.endTime,
        zone: DateTime.local().zoneName,
        status: this.selectedStatus?.value,
      };

      // Construct start and end date-time strings
      if (this.startDate && this.endDate) {
        const formattedStartDate = new Date(this.startDate);
        const formattedEndDate = new Date(this.endDate);

        const startYear = formattedStartDate.getFullYear();
        const startMonth = String(formattedStartDate.getMonth() + 1).padStart(
          2,
          "0"
        );
        const startDay = String(formattedStartDate.getDate()).padStart(2, "0");
        const endYear = formattedEndDate.getFullYear();
        const endMonth = String(formattedEndDate.getMonth() + 1).padStart(
          2,
          "0"
        );
        const endDay = String(formattedEndDate.getDate()).padStart(2, "0");

        params.start = `${startYear}-${startMonth}-${startDay}`;
        params.end = `${endYear}-${endMonth}-${endDay}`;
      }

      Object.keys(params).forEach((key) => {
        if (!params[key]) {
          delete params[key];
        }
      });

      this.saveFiltersToSessionStorage();

      const formData = new FormData();

      if (this.filterImage) {
        formData.append("image", this.filterImage);
      } 

      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });

      axios.post(
        "https://api.varsanpr.com/customer/face-portal/faces/search", 
        formData,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status === 200 && siteId === this.selectedSiteId) {
          response.data.faces.forEach((face) => {
            face.showing = this.showing;
            face.created_at_formatted = this.formatDateTime(face.created_at);
            face.age_range = this.formatAgeRange(face.age.min, face.age.max);
          });
          this.faces = response.data.faces;
          this.pagination.total = response.data.total;
          this.pagination.maxPage = Math.ceil(
            response.data.total / this.pagination.showing
          );

          // Scroll to the top of the page
          window.scrollTo(0, 0);
        }
        this.loading = false;
      })
      .catch((err) => {
        console.error("Error fetching faces:", err);
        this.loading = false;
      });

    },

    handleFilterImageSelection(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      this.filterImage = file;
      
      // Create a preview of the selected image
      const reader = new FileReader();
      reader.onload = (e) => {
        this.filterImagePreview = e.target.result;
      };
      reader.readAsDataURL(file);

      this.fetchFaces();
    },

    clearFilterImage() {
      this.filterImage = null;
      this.filterImagePreview = null;
      const fileInput = document.getElementById('filterImage');
      if (fileInput) fileInput.value = '';
      
      this.fetchFaces();
    },

    toggleBlur() {
      this.privacyFilter = !this.privacyFilter;
      localStorage.setItem("privacyFilter", this.privacyFilter);
    },

    formatDateTime(timestamp) {
      const date = new Date(timestamp * 1000); // Convert to milliseconds
      return (
        date.toLocaleDateString("en-GB") +
        " " +
        date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
      );
    },

    formatAgeRange(min, max) {
      return `${min} - ${max}`;
    },

    findSimilarFaces(selectedFace) {
      // Implement the logic to find similar faces based on the selected face
      // You can make an API call or perform any necessary actions here
      console.log("Finding similar faces for:", selectedFace);
    },

    reportIncident(face) {
      if (this.selectionModeActive && this.selectedFaces.length > 0) {
        const incidentParams = {
          created_at: this.selectedFace[0].created_at,
          faceSas: this.selectedFaces[0].images.head.sas,
          backgroundSas: this.selectedFaces[0].images.background.sas,
          site_id: this.selectedFaces[0].site_id,
          customIncident: false,
          faces: this.selectedFaces.map(face => face.id)
        };

        sessionStorage.setItem("incidentParams", JSON.stringify(incidentParams));
        
        this.$router.push({
          name: "NewIncident",
        });
      } else {
        const incidentParams = {
          faceId: face.id,
          created_at: face.created_at,
          faceSas: face.images.head.sas,
          backgroundSas: face.images.background.sas,
          site_id: face.site_id,
          customIncident: false,
          faces: [face.id]
        };

        sessionStorage.setItem("incidentParams", JSON.stringify(incidentParams));

        this.$router.push({
          name: "NewIncident",
        });
      }
    },
  
    selectFace(index) {
      if (this.selectionMode === 'single') {
        this.selectedFaceIndex = index;
        this.selectedFaceIndicies = [index];
      } else {
        const existingIndex = this.selectedFaceIndicies.indexOf(index);
        if (existingIndex >= 0) {
          this.selectedFaceIndicies.splice(existingIndex, 1);
        } else {
          this.selectedFaceIndicies.push(index);
        }
      }
    },

    isSelectedCustomFace(index) {
      if (this.selectionMode === 'single') {
        return this.selectedFaceIndex === index || (this.detectedFaces.length === 1 && index === 0);
      } else {
        return this.selectedFaceIndicies.includes(index);
      }
    },
  
    getBoundingBoxStyle(face) {
      const box = face.BoundingBox;

      return {
        left: `${box.Left * 100}%`,
        top: `${box.Top * 100}%`,
        width: `${box.Width * 100}%`,
        height: `${box.Height * 100}%`,
      }
    },

    handleImageSelection(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      this.faceDetectionStatus = null;
      this.faceDetectionError = null;
      
      this.newIncidentImage = file;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
        this.checkForFaceInImage();
      };
      reader.readAsDataURL(file);
    },
  
    checkForFaceInImage() {
      if (!this.newIncidentImage) {
        this.faceDetectionError = 'Please select an image first';
        this.faceDetectionStatus = 'error';
        return;
      }
      
      this.faceDetectionStatus = 'processing';
      
      const formData = new FormData();

      formData.append("image", this.newIncidentImage);
        
      axios.post(
        "https://api.varsanpr.com/customer/incident/incidents/detect",
        formData,
        { 
          headers: authHeader(),
          'Content-Type': 'multipart/form-data',
        }
      )
      .then((response) => {
        if (response.data.success && 
            response.data.detected_faces && 
            response.data.detected_faces.length > 0 &&
            response.data.detected_faces[0].FaceDetails && 
            response.data.detected_faces[0].FaceDetails.length > 0) {

          this.detectedFaces = response.data.detected_faces[0].FaceDetails;
          this.faceDetectionStatus = 'success';
          
          if (this.detectedFaces.length === 1) {
            this.selectedFaceIndex = 0;
            this.selectedFaceIndicies = [0]; 
          } else {
            this.selectedFaceIndex = null;
            this.selectedFaceIndicies = []; 
          }
        } else {
          this.faceDetectionStatus = 'error';
          this.faceDetectionError = 'No face detected in the image. Please upload a clear image with a visible face.';
          console.log("No face detected in image:", response.data);
        }
      })
      .catch((error) => {
        this.faceDetectionStatus = 'error';
        this.faceDetectionError = error.response?.data?.message || 'Error processing image';
        console.error("Error checking for face in image:", error);
      });
    },

    openNewIncidentModal() {
      this.resetNewIncidentForm();
      this.newIncidentModal.show();
    },

    resetNewIncidentForm() {
      this.newIncidentImage = null;
      this.imagePreview = null;
      this.faceDetectionStatus = null;
      this.faceDetectionError = null;
      this.hoveredFaceIndex = null;
      this.selectedFaceIndex = null;
      this.selectedFaceIndicies = [];
      this.selectionMode = 'single'; 
      
      const fileInput = document.getElementById('incidentImage');
      if (fileInput) fileInput.value = '';
    },

    createNewIncident() {
      if (this.faceDetectionStatus !== 'success') {
        return; 
      }
      
      if (this.selectionMode === 'single' && 
          this.detectedFaces.length > 1 && 
          this.selectedFaceIndex === null) {
        this.$error('Please select a face before continuing');
        return;
      }
      
      if (this.selectionMode === 'multiple' && 
          this.selectedFaceIndicies.length === 0) {
        this.$error('Please select at least one face before continuing');
        return;
      }

      this.newIncidentModal.hide();
      
      const base64String = this.imagePreview.split(',')[1];
      
      const incidentParams = {
        created_at: Math.floor(Date.now() / 1000),
        faceSas: this.imagePreview, 
        site_id: this.selectedSiteId,
        customIncident: true,
        images: [{ 
          data: base64String,
          name: this.newIncidentImage.name 
        }]
      };
      
      if (this.selectionMode === 'single') {
        const faceIndex = this.selectedFaceIndex !== null ?
                        this.selectedFaceIndex : 
                        (this.detectedFaces.length === 1? 0 : null);
        
        if (faceIndex !== null) {
          incidentParams.selectedFace = this.detectedFaces[faceIndex];
          incidentParams.singleFaceMode = true;
        }
      } else {
        if (this.selectedFaceIndicies.length > 0) {
          incidentParams.selectdFaces = this.selectedFaceIndicies.map(index => 
            this.detectedFaces[index]
          );
          incidentParams.multiFacesMode = true;
        }
      }
    
      sessionStorage.setItem("incidentParams", JSON.stringify(incidentParams));
      
      this.$router.push({
        name: "NewIncident",
      });
    },

    reportSelectedFaces() {
      if (this.selectedFaces.length === 0) {
        this.$error('Please select at least one face');
        return;
      }
      
      const mainFace = this.selectedFaces[0];

      const incidentParams = {
        created_at: mainFace.created_at,
        faceSas: mainFace.images.head.sas,
        backgroundSas: mainFace.images.background.sas,
        site_id: mainFace.site_id,
        customIncident: false,
        faces: this.selectedFaces.map(face => face.id)
      };

      sessionStorage.setItem("incidentParams", JSON.stringify(incidentParams));

      this.selectionModeActive = false;
      this.selectedFaces = [];

      this.$router.push({
        name: "NewIncident",
      });
    },
    
    isCreateButtonDisabled() {
      if (this.faceDetectionStatus !== 'success') {
        return true;
      }
      
      if (this.selectionMode === 'single') {
        return this.detectedFaces.length > 1 && this.selectedFaceIndex === null;
      } else {
        return this.selectedFaceIndicies.length === 0;
      }
    },

    saveFiltersToSessionStorage() {
      const clientId = this.$store.state.auth.user.selectedClient;
      const filtersToSave = {
        startDate: this.startDate || null,
        endDate: this.endDate || null,
        startTime: this.startTime || null,
        endTime: this.endTime || null,
        selectedSiteId: this.selectedSiteId || null,
        selectedStatus: this.selectedStatus ? this.selectedStatus.value : null,
        // gender: this.gender || null,
        // facialHair: this.facialHair || null,
        // glasses: this.glasses || null
      };
      sessionStorage.setItem(`portalFacesFilters_${clientId}`, JSON.stringify(filtersToSave));
    },

    restoreFiltersFromSessionStorage() {
      try {
        const clientId = this.$store.state.auth.user.selectedClient;
        const savedFilters = sessionStorage.getItem(`portalFacesFilters_${clientId}`);
        
        if (this.sites.length > 0) {
          this.selectedSite = this.sites[0];
          this.selectedSiteId = this.sites[0].id;
        }
        
        if (!savedFilters) {
          this.fetchFaces(1, this.selectedSiteId);
          return;
        }
        
        const filters = JSON.parse(savedFilters);
    
        if (filters.selectedSiteId && this.sites.length > 0) {
          const savedSite = this.sites.find(site => 
            String(site.id) === String(filters.selectedSiteId)
          );
          
          if (savedSite) {
            this.selectedSite = savedSite;
            this.selectedSiteId = savedSite.id;
          }
        }
        
        if (!this.selectedSiteId) {
          this.fetchFaces(1, this.selectedSiteId);
          return;
        }
        
        this.startDate = filters.startDate || null;
        this.endDate = filters.endDate || null;
        this.startTime = filters.startTime || null;
        this.endTime = filters.endTime || null;
        
        if (filters.selectedStatus && this.statuses.length > 0) {
          this.selectedStatus = this.statuses.find(status => 
            status.value === filters.selectedStatus
          ) || null;
        }
        
        // this.gender = filters.gender || null;
        // this.facialHair = filters.facialHair || null;
        // this.glasses = filters.glasses || null;
        
        this.$nextTick(() => {
          this.fetchFaces(1, this.selectedSiteId);
        });
      } catch (error) {
        console.error('Error restoring faces filters from session storage:', error);
        if (this.sites.length > 0) {
          this.fetchFaces(1, this.selectedSiteId);
        }
      }
    },

    clearFilters() {
      // Reset filter values to their initial state
      const currentSiteId = this.selectedSiteId;
      const currentSite = this.selectedSite;
      this.startDate = null;
      this.endDate = null;
      this.startTime = null;
      this.endTime = null;
      this.gender = null;
      this.beard = null;
      this.glasses = null;
      this.selectedStatus = null;
      this.filterImage = null;
      this.filterImagePreview = null;
      this.selectedSiteId = currentSiteId;
      this.selectedSite = currentSite;
      
      const fileInput = document.getElementById('filterImage');
      if (fileInput) fileInput.value = '';
      
      const clientId = this.$store.state.auth.user.selectedClient;
      sessionStorage.removeItem(`portalFacesFilters_${clientId}`);
      
      this.fetchFaces();
    },

    toggleImage(face) {
      if (face.showing === "face") {
        face.showing = "background";
      } else {
        face.showing = "face";
      }
    },

    toggleAllImages() {
      if (this.showing === "face") {
        this.showing = "background";
      } else {
        this.showing = "face";
      }

      this.faces.forEach((face) => {
        face.showing = this.showing;
      });
    },

    getFaceItemClass(face) {
      if (this.selectedFace === face) {
        return "card-expanded";
      } else {
        return "card";
      }
    },

    async loadSites() {
      try {
        const response = await ClientService.getClientSites(
          this.$store.state.auth.user.selectedClient,
          null,
          null,
          5
        );
        this.sites = response.data.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });

        if (this.sites.length > 0) {
          this.restoreFiltersFromSessionStorage();
        } else {
          this.loading = false;
        }
      } catch (error) {
        console.error("Error loading sites:", error);
        this.loading = false;
      }
    },

    async testSite(siteId) {
      try {
        const response = await axios.get(
          "https://api.varsanpr.com/customer/faces/faces",
          {
            params: {
              site_id: siteId,
              page: 1,
              count: this.pagination.pageSize,
            },
            headers: authHeader(),
          }
        );

        // Check if the response is successful and faces data is available
        if (
          response.status === 200 &&
          response.data.faces &&
          response.data.faces.length > 0
        ) {
          return true; // Site is working and has faces data
        }
        return false; // Site may not have faces data or not working
      } catch (error) {
        console.error(`Error testing site ${siteId}:`, error);
        return false; // Site is not working
      }
    },

    onSiteChange() {
      this.fetchFaces(1);
      this.selectedSiteId = this.selectedSiteId;
      localStorage.setItem("selectedSiteId", this.selectedSiteId);
    },

    toggleSelectionMode() {
      this.selectionModeActive = !this.selectionModeActive;

      if (!this.selectionModeActive) {
        this.selectedFaces = [];
      }
    },

    toggleFaceSelection(face) {
      if (!this.selectionModeActive) {
        this.selectedFace = this.selectedFace === face ? null : face;
        return; 
      }

      const index = this.selectedFaces.findIndex(f => f.id === face.id);

      if (index >= 0) {
        this.selectedFaces.splice(index, 1);
      } else {
        this.selectedFaces.push(face);
      }
    },

    isSelectedStandard(face) {
      return this.selectedFaces.some(f => f.id === face.id);
    },

    saveScrollPosition() {
      this.scrollPosition = window.scrollY;
    },
    restoreScrollPosition() {
      window.scrollTo(0, this.scrollPosition);
    },
  },
  computed: {
    selectedSiteId: {
      get() {
        return this.selectedSite ? this.selectedSite.id : null;
      },
      set(value) {
        this.selectedSite = this.sites.find((site) => site.id === value);
      },
    },
    timeSinceLastEvent() {
      if (!this.faces || this.faces.length === 0) return null;
      const lastEventTime = Math.max(
        ...this.faces.map((face) => face.created_at)
      );
      const currentTime = Math.floor(Date.now() / 1000);
      const timeDifference = currentTime - lastEventTime;
      const secondsInHour = 3600;

      if (timeDifference <= secondsInHour) return null;
      const secondsInDay = 86400;
      const secondsInMonth = 2592000;

      if (timeDifference >= secondsInMonth) {
        const months = Math.floor(timeDifference / secondsInMonth);
        return `last face ${months} month${months > 1 ? "s" : ""} ago`;
      }

      if (timeDifference >= secondsInDay) {
        const days = Math.floor(timeDifference / secondsInDay);
        return `last face ${days} day${days > 1 ? "s" : ""} ago`;
      }

      const hours = Math.floor(timeDifference / secondsInHour);
      return `last face ${hours} hour${hours > 1 ? "s" : ""} ago`;
    },
  },
};
</script>

<style scoped>
.faces-gallery {
  justify-content: center; /* Center the items in the gallery */
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  /* Align items at the start of the cross axis */
}

.card,
.card-expanded {
  margin: 10px;
  padding: 10px;
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-self: start;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /* Prevent stretching to match height of expanded items */
}

.card:hover,
.card-expanded:hover {
  box-shadow: 5px 5px 5px rgba(255, 255, 255, 0.1);
}

.card {
  width: 400px;
}

.card-expanded {
  width: 400px;
  /* You can adjust the width to your preference */
  /* You can adjust the padding to create more space */
}

.face-image {
  width: 100%;
  height: 250px;
  object-fit: cover;
  margin: auto;
}

.face-details {
  margin-top: 10px;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.btn-success:hover {
  background-color: #218838;
}

.card-expanded .face-image {
  width: 100%;
  /* Larger size for expanded image */
  height: auto;
  /* Larger size for expanded image */
  border-radius: 10px;
  /* Removes the round shape to make it a box */
}

/* Ensuring the expanded class has a larger image size than the default item */
.card .face-image {
  width: 100%;
  /* Keep the original size */
  height: 250px;
  /* Keep the original size */
}

.blurred .face-image {
  filter: blur(5px);
  transition: filter 0.3s ease;
}

.zoomedBlurred .face-image {
  filter: blur(10px);
  transition: filter 0.3s ease;
}

.blurred .face-image:hover {
  filter: none;
}

.zoomedBlurred .face-image:hover{
  filter: none;
}

.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image-container:hover {
  transform: scale(0.95);
  cursor: pointer;
}

.image-container::before {
  border-radius: 10px 10px 0 0;
  content: "\e8ff";
  font-family: "Material Icons";
  font-size: 36px;
  color: rgba(255, 255, 255, 0.9);
  background-color: rgba(22, 22, 22, 0.384);
  width: 75px;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.image-container:hover::before {
  opacity: 1;
}

.alert-border {
  border: 2px solid var(--utility-red);
}

.image-container button {
  position: absolute;
  top: 5px;
  left: 5px;
}

.face-controls {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.burger {
  width: 35px;
  height: 35px;
  line-height: 35px !important;
  position: relative;
  overflow: hidden;
  z-index: 1;
  padding: 0;
  border-radius: 0;
  vertical-align: middle !important;
  border-radius: 5px;
}

.burger i {
  vertical-align: middle !important;
  line-height: 35px !important;
  margin: 0 !important;
  font-size: 24px !important;
}

.wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 60vh;
}

.sub-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-preview-container {
  position: relative;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  max-width: 100%;
  width: auto;
}

.image-preview-container img {
  max-height: 300px;
  display: block;
  margin: 0 auto;
}

.face-bounding-box {
  position: absolute;
  border: 2px solid rgba(0, 123, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.face-box-hover {
  border-color: rgba(0, 123, 255, 0.8);
  background-color: rgba(0, 123, 255, 0.2);
}

.face-box-selected {
  border: 3px solid #28a745;
  background-color: rgba(40, 167, 69, 0.2);
}

.selection-indicator {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.selection-indicator i {
  color: #28a745;
  font-size: 24px;
}

.selected-face {
  border: 3px solid #28a745 !important;
  box-shadow: 0 0 10px rgba(40, 167, 69, 0.5);
}

.selection-mode {
  cursor: pointer;
}

.selection-mode:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}
</style>
